// @flow
import React from 'react';
import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';

type Props = {
    setIsOpen: (isOpen: boolean) => void,
    confirm: Function,
    cancel: Function,
};

export default function ProjectWarningModal({ setIsOpen, confirm, cancel, ...props }: Props) {
    return (
        <ModalTransition>
            <Modal {...props} shouldScrollInViewport onClose={() => setIsOpen(false)} appearance="warning">
                <ModalHeader>
                    <ModalTitle>Warning</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>Issues in removed project(s) might use this component.</p>
                    <p>Do you want to proceed?</p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        appearance="warning"
                        id="remove"
                        onClick={() => {
                            setIsOpen(false);
                            confirm();
                        }}
                    >
                        Remove
                    </Button>
                    <Button
                        id="cancel"
                        onClick={() => {
                            cancel();
                            setIsOpen(false);
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </ModalTransition>
    );
}
